import { TTProtection } from "../TTProtection";
import { ttProtectionDefaultValues } from "./ttProtectionDefaultValues";
import { useAddTTProtection } from "../Hooks/useAddTTProtection";
import { TTProtectionFormTabs } from "./TTProtectionFormTabs";

export default function AddTTProtection() {
  const { mutate: addTTProtection } = useAddTTProtection();

  return (
    <TTProtectionFormTabs
      title="Add TT Protection"
      ttProtection={ttProtectionDefaultValues}
      onSaveAsNewVersion={(ttProtection: TTProtection) => addTTProtection(ttProtection)}
    />
  );
}
